module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAGCAYAAADgzO9IAAAAHUlEQVQYV2NkYGD4z8DAwIhOgwSwAgyVMJ1U1AEAGqwJBzo2G9QAAAAASUVORK5CYII="